import { Box } from "@mui/material";
import { Dayjs } from "dayjs";
import { memo } from "react";
import { LoadingInterval } from "./locationLoadingIntervals";
import { TimelineSlot } from "./timelineLayout";

interface LocationLoadingStripProps {
  intervals: readonly LoadingInterval[];
  slot: TimelineSlot;
  getPositionPercent: (time: Dayjs) => number;
}

export const LocationLoadingStrip = memo(
  ({ intervals, slot, getPositionPercent }: LocationLoadingStripProps) => {
    return (
      <>
        {intervals.map((interval) => {
          const leftPercent = Math.max(0, getPositionPercent(interval.start));
          const widthPercent = Math.min(
            100 - leftPercent,
            getPositionPercent(interval.end) - leftPercent
          );

          return (
            <Box
              key={interval.start.toISOString()}
              sx={{
                position: "absolute",
                left: `${leftPercent}%`,
                width: `${Math.max(widthPercent, 0.5)}%`,
                top: slot.top,
                height: slot.height,
                bgcolor: "data.green",
                borderRadius: slot.borderRadius,
                pointerEvents: "none",
              }}
            />
          );
        })}
      </>
    );
  }
);
LocationLoadingStrip.displayName = "LocationLoadingStrip";
